<mat-spinner *ngIf="isLoading"></mat-spinner>

<div class="form-container sign-in-container">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <form *ngIf='!isLoading' (submit)='onLogin(loginForm)' #loginForm="ngForm">
    <nb-card>
      <nb-card-body fxLayout="column">
        <span>
          <img src="../../../assets/logo2.png" alt="" srcset="" style="width: 112px;height: 112px;">
        </span>
        <div fxLayout="column" *ngIf="!isOtpSent">
          <h3>Sign in to eGlu console</h3>
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input type="email" name="email" ngModel matInput required email placeholder="e-mail" #emailInput="ngModel">
          <mat-error *ngIf="emailInput.invalid">"please enter valid email"</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input type="password" name="password" matInput ngModel placeholder="Password" #passwordInput="ngModel"
            required>
          <mat-error *ngIf="passwordInput.invalid">"please enter valid password"</mat-error>
        </mat-form-field>
        <a (click)="forgotPassword()">Forgot your password?</a>
        <button type="submit" *ngIf="!isLoading">Sign In</button>
        <!-- <a href="/signup">Create a new account!</a> -->
        </div>
        <div *ngIf="isOtpSent">
          <h4>2-Factor Authentication</h4>
          <span>Please enter the OTP sent to your registered Email ID</span>
          <mat-form-field appearance="outline">
            <mat-label>OTP</mat-label>
            <input type="number" name="otp" matInput ngModel placeholder="OTP" [(ngModel)]="otp"
              required>
          </mat-form-field>
          <button type="submit" *ngIf="!isLoading">Verify OTP</button>
        </div>
      </nb-card-body>
    </nb-card>
  </form>
</div>
